import React, { useState } from "react";
import { REMINDER_OPTIONS } from "../utils/taskReminderSync";

const ReminderPicker = ({
    value = "none",
    customMinutes = 15,
    onChange,
    disabled = false,
    className = "",
    compact = false,
}) => {
    const [custom, setCustom] = useState(customMinutes);

    const handlePresetChange = (preset) => {
        if (preset === "custom") {
            onChange?.({ preset: "custom", customMinutes: custom });
            return;
        }
        onChange?.({ preset, customMinutes: 0 });
    };

    const handleCustomChange = (mins) => {
        const parsed = Math.max(1, Number(mins) || 1);
        setCustom(parsed);
        onChange?.({ preset: "custom", customMinutes: parsed });
    };

    if (compact) {
        return (
            <select
                className={className}
                value={value}
                disabled={disabled}
                onChange={(e) => handlePresetChange(e.target.value)}
            >
                {REMINDER_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        );
    }

    return (
        <div className={className}>
            <select
                className="w-full rounded-md border border-line bg-surface px-2 py-1.5 text-xs text-ink outline-none focus:border-primary"
                value={value}
                disabled={disabled}
                onChange={(e) => handlePresetChange(e.target.value)}
            >
                {REMINDER_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            {value === "custom" && (
                <div className="mt-2 flex items-center gap-2">
                    <input
                        type="number"
                        min={1}
                        max={10080}
                        value={custom}
                        disabled={disabled}
                        onChange={(e) => handleCustomChange(e.target.value)}
                        className="w-24 rounded-md border border-line bg-surface px-2 py-1 text-xs text-ink outline-none focus:border-primary"
                    />
                    <span className="text-xs text-ink-muted">minutes before</span>
                </div>
            )}
        </div>
    );
};

export default ReminderPicker;
